module.exports = __webpack_public_path__ + "static/media/bg.5755ae07.jpg";